import React from 'react';
import RightSidebarForm from 'Views/Page/Content/RightSidebar/Content/RightSidebarForm';
import PropTypes from 'prop-types';
import metaOverrideSet from '../DefaultTemplate/MetaOverrideSet';
import layout from './layout';

const PerformanceCommentaryTemplate = ({
  collection,
}) => {
  return (
    <RightSidebarForm
      Layout={layout}
      collection={collection}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

PerformanceCommentaryTemplate.propTypes = {
  collection: PropTypes.object.isRequired,
};

export default PerformanceCommentaryTemplate;
